/* oxlint-disable unicorn/prefer-spread */
/* disable because dom.iterable not implemented and spread operator is not working without */
import { Component, Input } from "@angular/core";

@Component({
    selector: "h-notification-message",
    templateUrl: "./notification-message.component.html",
    styleUrls: ["./notification-message.component.scss"],
})
export class NotificationMessageComponent {
    @Input({ required: true })
    public notificationMessage!: string;
}
